import React from "react";

const MilesRevolutionMobile = () => {
  return (
    <>
      {/* // Mobile version */}
      <div className="flex w-full justify-center py-10  bg-[#F4F4F4] md:hidden">
        <div className="flex flex-col px-1 items-center w-full max-w-[350px]">
          {/* Title Section */}
          <h2 className="text-[24px] font-semibold text-[#1D1D1D] mb-4 text-center leading-normal tracking-[-0.96px]">
            Miles is More Than Education;
            <span className="border-[#ca7216] border-b-2 leading-normal tracking-[-0.96px]">
              <br /> It’s a Revolution
            </span>
          </h2>

          {/* Cards Section */}
          <div className="grid grid-cols-1 gap-4 w-full mb-6">
            <div className="grid grid-cols-2 bg-white p-4 rounded-[16px] text-center shadow-md w-full items-center justify-between">
              <h3 className="text-[40px] font-bold text-[#3174d6] mb-0 md:text-left leading-[116%]">
                70k +
              </h3>
              <p className="text-[#5C5C5C] text-[20px] font-medium md:text-right leading-[116%] tracking-[-0.8px]">
                Global Alumni
              </p>
            </div>

            <div className="grid grid-cols-2 bg-white p-4 rounded-[16px] text-center shadow-md w-full items-center ">
              <h3 className="text-[40px] font-bold text-[#008D82] mb-0 md:text-left leading-[116%]">
                700 +
              </h3>
              <p className="text-[#5C5C5C] text-[20px] font-medium mt-0 leading-[116%] tracking-[-0.8px]">
                Professionals
              </p>
            </div>

            <div className="grid grid-cols-2 bg-white p-4 rounded-[16px] text-center shadow-md w-full items-center justify-between">
              <h3 className="text-[40px] font-bold text-[#FFBA08] mb-0 md:text-left leading-[116%]">
                600 +
              </h3>
              <p className="text-[#5C5C5C] text-[20px] font-medium leading-[116%] tracking-[-0.8px]">
                Corporates
              </p>
            </div>

            <div className="grid grid-cols-2 bg-white p-4 rounded-[16px] text-center shadow-md w-full items-center justify-between">
              <h3 className="text-[40px] font-bold text-[#BD132D] mb-0 md:text-left leading-[116%]">
                100 +
              </h3>
              <p className="text-[#5C5C5C] text-[20px] font-medium leading-[116%] tracking-[-0.8px]">
                Universities
              </p>
            </div>
          </div>

          {/* Content Section */}
          <div className="w-full text-center">
            <h3 className="text-[20px] font-semibold text-[#071B30] mb-2 leading-[116%]">
              Bootstrapped and Ballistic
            </h3>
            <hr className="w-10 mx-auto mb-4" />
            <p className="text-[#5C5C5C] text-[18px] font-normal leading-[24px] tracking-[-0.72px]">
              We’re a self-made success story,
              <br />
              focusing steadfastly on fundamentals <br />
              and outcomes rather than external <br />
              fundraising. Growing at an astonishing <br />
              CAGR of 70%+ and distinguished as one <br />
              of the few profitable Ed-Tech <br />
              companies in India, we are poised for
              <br />
              substantial growth.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MilesRevolutionMobile;
